var common = {
  'message.error.xml2json': 'Error in converting XML to JSON, please check whether the XML format is wrong'
};
export { common as default };
